
import { Button, Modal } from '@/shared/components'
import { DialogComponentProps } from '@/shared/components/Modal/models/DialogStructure'
import { styled, Typography } from '@mui/material'

export type ConfirmDialogProps = DialogComponentProps & {
  onClose: () => void
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, onClose, title, message, onConfirm, actionText = 'Confirm' }) => {
  return (
    <Modal
      title={title}
      onClose={onClose}
      open={open}
      transition="opacity"
      showBackground={true}
    >
      <StyledContent>
        <Typography variant="body1">{message}</Typography>

        <StyledFormActions>
          {onClose && <Button text onClick={onClose}>Cancel</Button>}
          <Button primary onClick={async () => {
            await onConfirm()
            onClose()
          }}>
            {actionText}
          </Button>
        </StyledFormActions>
      </StyledContent>
    </Modal>
  )
}

const StyledContent = styled('div')`
  ${(props) => props.theme.breakpoints.up('sm')} {
    min-width: ${(props) => props.theme.typography.pxToRem(540)};
  }
`

const StyledFormActions = styled('div')`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: ${(props) => props.theme.typography.pxToRem(12)};
  margin-top: ${(props) => props.theme.typography.pxToRem(16)};
`
